import * as actionTypes from "./actionTypes";
import axios from "axios";
import { logFirebaseEvent } from "../../shared/utility";

export const submitBillsSuccess = (submittedBillsDetails) => {
  return {
    type: actionTypes.SUBMIT_BALANCEBILLS_SUCCESS,
    submittedBillsDetails: submittedBillsDetails,
  };
};
export const submitBillsFailed = (error) => {
  return {
    type: actionTypes.SUBMIT_BALANCEBILLS_FAILED,
    payload: error,
  };
};
export const submitBillsStarted = () => {
  return {
    type: actionTypes.SUBMIT_BALANCEBILLS_STARTED,
  };
};

export const resetSubmitBills = () => {
  return {
    type: actionTypes.RESET_SUBMIT_BALANCEBILLS,
  };
};
export const submitBills = (formdata: FormData) => {
  // for (var value of formdata.values()) {
  //   console.log(value);
  // }
  return (dispatch) => {
    dispatch(submitBillsStarted());
    const submitBillsUrl = `${process.env.REACT_APP_SUBMIT_BILLS}`;
    axios
      .post(
        submitBillsUrl,
        // "https://cors-anywhere.herokuapp.com/https://portal-isuat.advancedpricing.com/api/v1/balance-bill",
        // "https://cors-anywhere.herokuapp.com/https://portal.advancedpricing.com/api/v1/balance-bill",
        formdata,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        console.log(response);
        dispatch(submitBillsSuccess(response.data));
      })
      .catch((error) => {
        let errorMessage = "";
        if (error.response && error.response.data) {
          if (error.response.data.fields) {
            errorMessage = error.response.data.fields;
          } else if (error.response.data.patientId) {
            errorMessage = error.response.data.patientId;
          } else if (error.response.data.fileNames) {
            errorMessage = error.response.data.fileNames;
          } else if (error.response.data.files) {
            errorMessage = error.response.data.files;
          } else if (error.response.data.claim) {
            errorMessage = error.response.data.claim;
          } else {
            errorMessage = "Network Error";
          }
        } else {
          errorMessage = "Network Error";
        }

        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(submitBillsFailed(errorMessage));
      });
  };
};
